import { useCallback } from 'react';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { useSupplierOfferPublishMutation } from 'api';
import { RemoveBrandModal } from './index';

export const useRemoveBrandModal = (props: Omit<RemoveBrandModal, 'openModal'>) => {
  const { onCancelModal, recordId } = props;
  const { handleError, handleSuccess } = useNotificationMessages();

  const [supplierOfferPublish, { isLoading }] = useSupplierOfferPublishMutation();

  const onCancel = useCallback(() => {
    onCancelModal();
  }, [onCancelModal]);

  const onFinish = useCallback(async () => {
    if (recordId) {
      try {
        const { data, error } = await supplierOfferPublish(recordId);
        if (data?.success) {
          handleSuccess('Brand was successfully published add to supplier offer.');
          onCancel();
        } else {
          handleError(error);
        }
      } catch (err) {
        handleError(err);
      }
    }
  }, [handleSuccess, onCancel, handleError, supplierOfferPublish, recordId]);

  return {
    onFinish,
    isLoading,
    onCancel,
  };
};
